<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md12
      >

      

        <v-dialog persistent
          v-model="dialog"
          width="1000"
          hegiht="auto"
        >
          <template v-slot:activator="{ on }">
                <v-flex  xs12 md4>
                  <v-btn
                    color="success"
                    dark
                    v-on="on"
                  >
                  Create new
                  </v-btn>
                </v-flex>
          </template>

          <v-card>        
              <!--<contest-form 
              :Item="item"
              :Field="inputFields"
              :Value="valueObj"
              @emitted="getBackData"
              @closed="closeModal"/>-->
            <v-form
              ref="form"
            >
                <v-container py-0>
                  <v-layout wrap>
                    <v-flex class="md6">
                      <v-select
                       :items="courseList"
                        label="Select Course"
                        item-text="name"
                        item-value="id"
                        class="mt-4"
                        v-model="modelTest.course_id"
                      ></v-select>
                    </v-flex>
                    <v-flex class="md6">
                     	  <v-text-field type="test"  v-model="modelTest.model_test_name"  class="mt-4" placeholder="Model test name"></v-text-field>
                    </v-flex>
                    
                    <v-flex class="md6">
                     	  <v-text-field type="number" v-model="modelTest.duration"  class="mt-4" placeholder="Duration"></v-text-field>
                    </v-flex>
                    
                    <v-flex class="md6">
                     	  <v-text-field type="number" v-model="modelTest.positive_mark"  class="mt-4" placeholder="Positive Mark"></v-text-field>
                    </v-flex>
                    
                    <v-flex class="md6">
                     	  <v-text-field type="number" v-model="modelTest.negative_mark" class="mt-4" placeholder="Negative Mark"></v-text-field>
                    </v-flex>
                    <v-flex class="md6">
                     	  <v-text-field type="number" v-model="modelTest.total_mark" class="mt-4" placeholder="Total Mark"></v-text-field>
                    </v-flex>
                    <v-flex class="md6">
                     	  <v-text-field type="number" v-model="modelTest.question_number" class="mt-4" placeholder="Question Number"></v-text-field>
                    </v-flex>
                    <v-flex class="md6">
                     	  <v-text-field type="number" v-model="modelTest.question_number_per_subject" class="mt-4" placeholder="Question Number Per Subject"></v-text-field>
                    </v-flex>
                    
                    <v-flex class="md6">
                      <label class="pr-2"> Question file upload : </label>
                     	  <input
                            type="file"
                            ref="excelFile"
                            @change="importExcel($event)"
                          >
                    </v-flex>
                    
                

                    <v-flex
                      xs12
                      text-xs-right>
                      <v-btn
                        class="mx-0 font-weight-light"
                        color="success" @click="onSubmit" >Save</v-btn>
                      <v-btn
                        class="mx-2 font-weight-light"
                        color="info" @click="closeModal">Close</v-btn>
                    </v-flex> 
                  </v-layout>
                </v-container>
              </v-form>

            <v-divider/>
          </v-card>
        </v-dialog>
        <material-card
          color="green"
          title="Special model test list"
        >

          <v-data-table
            :headers="headers"
            :items="specialModelTestList"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td> {{ item.exam_name }}</td>
              <td>{{ item.unit }}</td>           
              <td>{{ item.status }} </td> 
             
            </template>
          </v-data-table>
        </material-card>

            <v-snackbar
              :color="color"
              :bottom="bottom"
              :top="top"
              :left="left"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div> {{ noticeMessage }}</div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
// import Form from '@/views/Form'
import xlsx from "xlsx";
export default {
  // components: {
  //   Form
  // },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState('specialModelTest', ['specialModelTestList']),
  },
  mounted () {
    this.GetSpecialModelTestList()
  },
  data () {
    return {
    modelTest: {},
    questions : [],
    color: null,
    colors: ['warning'],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
    
    headers: [
      {
        sortable: true,
        text: 'Question',
        value: 'exam_name'
      },
       {
        sortable: false,
        text: 'Unit',
        value: 'unit'
      },     
      {
        sortable: false,
        text: 'Status',
        value: 'status'
      }    
    ],
      dialog: false,
      noticeMessage: '',
      item: {
        'title': 'Special Model Test',
        'subTitle': 'Create special model test',
        'submitText' : 'Submit'
      },
      valueObj: {},
      courseList: [{id:27,name:"C Unit"},{id:13,name:"B Unit"},{id:15,name:"D Unit"}]
    }
  },
  created () {
  },
  methods: {
      ...mapActions("specialModelTest", ["GetSpecialModelTestList","storeSpecialModelTest"]),

    getBackData (data) {
          this.color = data.status === "OK" ? "success": "warning"
          if (data.status === "OK") {
            this.noticeMessage = "Success! " + data.messages;
            this.dialog = false
          } else {
            this.noticeMessage = "Warning! " + data.messages;
          }
          this.snack("top");
    },

    importExcel(e) {   
      const files = e.target.files;     
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        return alert(
          "The upload format is incorrect. Please upload xls or xlsx format"
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
  
          this.questions = [];
          // Edit data
          for (var i = 0; i < ws.length; i++) {             
       
            this.questions.push({
              subject_id: ws[i].subject_id,
              question: ws[i].question,
              option1: ws[i].option1,
              option2: ws[i].option2,
              option3: ws[i].option3,
              option4: ws[i].option4,
              option5: ws[i].option5 ? ws[i].option5 : null,
              option6: ws[i].option6 ? ws[i].option6 : null,
              correct_answer: ws[i].correct_answer ? ws[i].correct_answer : null ,
              correct_answer2: ws[i].correct_answer2 ? ws[i].correct_answer2 : null ,
              correct_answer3: ws[i].correct_answer3 ? ws[i].correct_answer3 : null ,
              correct_answer4: ws[i].correct_answer4 ? ws[i].correct_answer4 : null ,
              correct_answer5: ws[i].correct_answer5 ? ws[i].correct_answer5 : null ,
              correct_answer6: ws[i].correct_answer6 ? ws[i].correct_answer6 : null 
            });
          
          
          }

          // if(this.excelQuestions.length > 0){
          //  // this.uploadQuestions();
          // }
     
        } catch (e) {
          return alert("Read failure!");
        }
      };
      fileReader.readAsBinaryString(files[0]);
      
    },

    closeModal () {
      this.dialog = false
      this.$refs.form.reset()
      this.questions = []
    },
    onSubmit() {
      let unit;
      switch (this.modelTest.course_id) {
        case 27:
          unit = 'c'
          break;
       case 13:
          unit = 'b'
          break;
       case 15:
          unit = 'd'
          break;
      }

    const obj = {
        course_id: this.modelTest.course_id,
        model_test_name: this.modelTest.model_test_name,
        duration: Number(this.modelTest.duration),
        total_mark:   Number(this.modelTest.total_mark),
        question_number:   Number(this.modelTest.question_number),
        positive_mark:   Number(this.modelTest.positive_mark),
        negative_mark:   Number(this.modelTest.negative_mark),
        question_number_per_subject:   Number(this.modelTest.question_number_per_subject),
        status: "Available",
        unit:  unit,
        questions : this.questions
    }


      this.storeSpecialModelTest(obj).then(response => {
        console.log(response)
        if (response.status == "OK") {         
          this.closeModal();
          this.color = "success";        
          this.noticeMessage = "Success! " + response.messages;
          this.snack("top");
        } else {
          this.color = "warning";
          this.noticeMessage = "Warning! " + response.messages;
          this.snack("top");
        }
      });
     
    },

    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false

      for (const loc of args) {
        this[loc] = true
      }

      // this.color = this.colors[Math.floor(Math.random() * this.colors.length)]

      this.snackbar = true
    }
  }
}
</script>
